export default __webpack_public_path__ + "static/media/martin_whiskas.3ef241ce.jpg";